import React, { useState, useEffect } from 'react';
import AxiosClient from '../../assets/AxiosClient';
import { useNavigate, useParams } from 'react-router-dom';
import { useStateContext } from '../../Contexts/ContextProvider';
import Loader from '../../assets/tools/Loder/loader';
import { DataTable, PageHeader } from '../../componants/Workspace';

const SectionSort = () => {
  const [sections, setSections] = useState([]);
  const [loading, setIsloading ] = useState (true) ; 

  const navigate = useNavigate();
  const { API } = useStateContext();
    const {id , lang } = useParams () ; 
  useEffect(() => {
    const fetchSections = async () => {
      try {
        const response = await AxiosClient.get(`/conferences/${id}/sections/${lang}`);
        setSections(response.data);
      } catch (error) {
        console.error('Error fetching sections:', error);
      }finally {
        setIsloading(false) ;
    }
    };

    fetchSections();
  }, []);

  const moveSectionUp = (index) => {
    if (index > 0) {
      const newSections = [...sections];
      [newSections[index - 1], newSections[index]] = [
        newSections[index],
        newSections[index - 1],
      ];
      setSections(newSections);
    }
  };

  const moveSectionDown = (index) => {
    if (index < sections.length - 1) {
      const newSections = [...sections];
      [newSections[index], newSections[index + 1]] = [
        newSections[index + 1],
        newSections[index],
      ];
      setSections(newSections);
    }
  };

  const saveRanks = async () => {
    try {
      // Prepare the payload
      setIsloading(true) ; 
      const updatedSections = sections.map((section, index) => ({
        id: section.id,
        rank: index + 1,
      }));

      // Send the update request
      await AxiosClient.post('/sections/update_rank', { sections: updatedSections });

      console.log('Ranks updated successfully!');
      navigate(-1);
    } catch (error) {
      console.error('Error updating ranks:', error);
    } 
  };
  if (loading ) {
    return (
      <>
        <PageHeader title="Section order" description="Arrange how sections appear to attendees." />
        <div className="workspace-loading"><Loader label="Loading section order..." /></div>
      </>
    );
  }

  return (
    <>
      <PageHeader
        title="Section order"
        description="Arrange how sections appear to attendees."
        actions={(
          <>
            <button className="btn btn-primary" onClick={saveRanks} type="button">Save order</button>
            <button className="btn btn-outline-secondary" onClick={() => navigate(-1)} type="button">Cancel</button>
          </>
        )}
      />
      <DataTable>
        <thead className="text-primary">
          <tr>
            <th className="text-center">Title</th>
            <th className="text-center">Description</th>
            <th className="text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          {sections.map((section, index) => (
            <tr
              key={section.id}
              className={`text-center ${
                index % 2 === 0 ? 'bg-gray-50' : 'bg-white'
              } transition-bg duration-1000`}
            >
              <td>{section.title}</td>
              <td>{section.description}</td>
              <td>
                <button className="btn btn-outline-secondary btn-sm" onClick={() => moveSectionUp(index)} type="button">
                  <i className="material-icons" aria-hidden="true">arrow_upward</i>
                  Move up
                </button>
                <button className="btn btn-outline-secondary btn-sm" onClick={() => moveSectionDown(index)} type="button">
                  <i className="material-icons" aria-hidden="true">arrow_downward</i>
                  Move down
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </DataTable>
    </>
  );
};

export default SectionSort;
